import React from 'react';
import { XIcon, RocketIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CtaButton } from './CtaButton';
export function CloseSection() {
  return <section className="w-full bg-zinc-950 py-12 sm:py-24" data-id="element-26">
      <div className="mx-auto max-w-4xl px-4" data-id="element-27">
        <Reveal data-id="element-28">
          <h2 className="text-center font-display text-2xl text-white sm:text-4xl" data-id="element-29">
            Tienes dos caminos frente a ti
          </h2>
        </Reveal>

        <div className="mt-8 grid gap-5 sm:mt-12 sm:grid-cols-2" data-id="element-30">
          <Reveal data-id="element-31">
            <div className="h-full rounded-2xl border border-zinc-800 bg-zinc-900/40 p-7 opacity-80" data-id="element-32">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-red-500/10 text-red-400" data-id="element-33">
                <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-34" />
              </span>
              <h3 className="mt-5 font-display text-xl text-zinc-300" data-id="element-35">
                Camino A
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-zinc-500" data-id="element-36">
                Seguir intentándolo solo, gastando meses y dinero en
                herramientas que no entiendes.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.08} data-id="element-37">
            <div className="cta-glow h-full rounded-2xl border border-orange-500/40 bg-orange-500/5 p-7" data-id="element-38">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-orange-500/15 text-orange-500" data-id="element-39">
                <RocketIcon className="h-6 w-6" aria-hidden="true" data-id="element-40" />
              </span>
              <h3 className="mt-5 font-display text-xl text-white" data-id="element-41">Camino B</h3>
              <p className="mt-2 text-sm leading-relaxed text-zinc-200" data-id="element-42">
                Dejar que la IA haga el trabajo pesado por ti hoy mismo por
                menos de lo que cuesta una salida al cine.
              </p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.1} data-id="element-43">
          <div className="mt-12 text-center" data-id="element-44">
            <CtaButton size="xl" className="w-full sm:w-auto" data-id="element-45">
              Sí, quiero acceso instantáneo por $47
            </CtaButton>
          </div>
        </Reveal>
      </div>
    </section>;
}